import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {RedirectGuard} from '@app/shared/guards/redirect.guard';
import {VideoLibraryBrowseComponent} from './help-components/video-library-browse/video-library-browse.component';
import {
  VideoLibraryIndividualComponent
} from './help-components/video-library-individual/video-library-individual.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'videos'
  },
  {
    path: 'articles',
    canActivate: [RedirectGuard],
    component: RedirectGuard,
    data: {
      externalUrl: 'https://help.frankli.io/'
    }
  },
  {
    path: 'videos',
    component: VideoLibraryBrowseComponent,
    data: { label: 'Training Videos' },
    children: [
      {
        path: ':id',
        component: VideoLibraryIndividualComponent,
        data: { label: 'Watch video' },
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HelpRoutingModule { }
